<div class="bg-gray-100 p-1 rounded-lg inline-flex">
  @for (tab of tabs; track tab.label) {
    @if (isRouterMode) {
      <a
        [routerLink]="tab.route"
        routerLinkActive="bg-white text-gray-900 shadow-sm"
        [routerLinkActiveOptions]="getRouteLinkOptions(tab)"
        class="px-3 sm:px-4 py-0.5 sm:py-1 text-[13px] font-medium rounded-md transition-all duration-200"
        [class.text-gray-600]="!isActive(tab)"
        [class.text-gray-900]="isActive(tab)"
      >
        {{ tab.label }}
      </a>
    } @else {
      <button
        type="button"
        class="px-3 sm:px-4 py-0.5 sm:py-1 text-[13px] font-medium rounded-md transition-all duration-200"
        [class.bg-white]="isActive(tab)"
        [class.text-gray-900]="isActive(tab)"
        [class.shadow-sm]="isActive(tab)"
        [class.text-gray-600]="!isActive(tab)"
        (click)="onTabSelect(tab)"
      >
        {{ tab.label }}
      </button>
    }
  }
</div>
